import { useMutation } from '@tanstack/react-query';
import { logger } from '@dist-marketplace-frontend/services';
import { dealerApi } from '../../../../api/dealerApi';

export const useTrackDealerShowroomCallMutation = () => {
  return useMutation({
    mutationFn: (dealerId: string) =>
      dealerApi.trackDealerShowroomCall(dealerId),
    onError: (err) => {
      logger.error({
        error: err,
        message: 'Error tracking dealer showroom phone call',
        tags: ['dealer-page', 'phone-call-event'],
      });
    },
  });
};
